import {client} from './client';
import {serialize} from "../utils";

export default class mapApi {

    /**
     * Get filter options for object search in public part
     * @returns {Promise<any>}
     */
    static async getSearchFiltersPublic() {
        let response = await client.get('/map/public/search_filters');
        return response.data;
    }

    static async getLayerGroups(filter) {
        let result = await client.get('/map/public/layer_groups?' + serialize(filter));
        return result.data;
    }

}